import { defineComponent, ref } from '@vue/composition-api';
export default defineComponent({
    name: 'PaymentBanner',
    setup() {
        const isOpen = ref(true);
        const close = () => {
            isOpen.value = false;
        };
        return {
            isOpen,
            close,
        };
    },
});
